/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-9 10:24:58
 */
import https from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'

// 查询企业号下的机器人列表
export const robotsSearch = (params: any) => {
	return https().request(`robots`, Method.GET, params, ContentType.form)
}

// 获取机器人系统状态
export const robotsSystemInfo = (params: any) => {
	return https().request(`robots/status/system`, Method.GET, params, ContentType.form)
}

// 获取机器人基础信息
export const robotsInfo = (params: any) => {
	return https().request(`robots/info`, Method.GET, params, ContentType.form)
}

// 获取机器人运行数据
export const robotsWorkData = (params: any) => {
	return https().request(`robots/work`, Method.GET, params, ContentType.form)
}

// 更新机器人名称
export const robotsUpdateName = (params: any,robotId: any) => {
	return https().request(`robots?id=${robotId}`, Method.PUT, params, ContentType.json)
}

// 获取任务查询列表
export const gettasklists = (params: any) => {
	return https().request(`task/report`, Method.GET, params, ContentType.form)
}

// 获取机器人电量
export const robotsBattery = (params: any) => {
	return https().request(`robots/status/battery`, Method.GET, params, ContentType.form)
}

// 获取机器人在线状态
export const robotsOnline = (params: any) => {
	return https().request(`robots/status/online`, Method.GET, params, ContentType.form)
}

// 获取机器人在线时间
export const robotsTime = (params: any) => {
	return https().request(`robots/status/time`, Method.GET, params, ContentType.form)
}

// 获取机器人激活码
export const robotsActiveCode = (params: any) => {
	return https().request(`robots/active_code`, Method.GET, params, ContentType.form)
}
// 获取机器人备注名
export const getaliasname = (params: any) => {
	return https().request(`task/robots/name`, Method.GET, params, ContentType.form)
}

// 获取机器人系统版本
export const getStatusVs = (params: any) => {
	return https().request(`robots/status/version`, Method.GET, params, ContentType.form)
}

// 获取机器人硬件状态
export const getStatusDstic = (params: any) => {
	return https().request(`robots/status/diagnostic`, Method.GET, params, ContentType.form)
}

// 获取机器人工作时长趋势
export const getWorktime = (params: any) => {
	return https().request(`stat/robots/worktime/trend`, Method.GET, params, ContentType.form)
}

// 楼宇配送次数排行榜
export const getbuildingOrder = (params: any) => {
	return https().request(`stat/task/building/order`, Method.GET, params, ContentType.form)
}

// 累计数量和占比
export const getTask = (params: any) => {
	return https().request(`stat/task/state`, Method.GET, params, ContentType.form)
}

// 主动拉取硬件状态
export const refresh_diag = (params: any) => {
	return https().request(`robots/status/refresh_diag`, Method.POST, params, ContentType.form)
}

// 主动拉取基本信息
export const refresh_info = (params: any) => {
	return https().request(`robots/status/refresh_info`, Method.POST, params, ContentType.form)
}

// 主动拉取系统状态
export const refresh_version = (params: any) => {
	return https().request(`robots/status/refresh_version`, Method.POST, params, ContentType.form)
}

// 机器人SIM卡流量查询
export const robotSIM = (params: any) => {
	return https().request(`robots/status/sim`, Method.GET, params, ContentType.form)
}




// 添加机器人
export const addRobot = (params: any) => {
	return https().request(`v1/robot-status/add`, Method.POST, params, ContentType.json)
}
// 获取机器人详情
export const getRobotDetail = (params: any) => {
	// return https().request('robot-status/all', Method.GET, params, ContentType.form)
	return https().request(`v1/robot-status/detail?serialNum=${params}`, Method.GET, params, ContentType.form)
}
// 任务管理列表
export const taskList = (params: any) => {
	return https().request('robot-status/task_info', Method.GET, params, ContentType.form)
}
// 任务详情
export const taskInfo = (params: any) => {
	return https().request('robot-status/task_detail', Method.GET, params, ContentType.form)
}
// 地图
export const mapInfo = (params: any) => {
	return https().request('robot-status/task_map', Method.GET, params, ContentType.form)
}
// 获取日志
export const getLog = (params: any) => {
	return https().request('robot-log/log', Method.GET, params, ContentType.form)
}
// 累计消杀次数
export const disinfectCount = (params: any) => {
	return https().request('tasks/disinfect/count', Method.GET, params, ContentType.form)
}
// 累计消杀时长
export const disinfectDuration = (params: any) => {
	return https().request('tasks/disinfect/duration', Method.GET, params, ContentType.form)
}
// 区域任务次数&消杀时长
export const areaTaskDisinfect = (params: any) => {
	return https().request('tasks/disinfect/area-statistics', Method.GET, params, ContentType.form)
}
// 区域下每个房间的任务次数&消杀时长
export const roomTaskDisinfect = (params: any) => {
	return https().request('tasks/disinfect/room-statistics', Method.GET, params, ContentType.form)
}
// 机器人消杀频率
export const robotDisinfect = (params: any) => {
	return https().request('tasks/disinfect/robot-statistics', Method.GET, params, ContentType.form)
}

// 重置机器人登录密码
export const resetLogin = (params: any) => {
	return https().request(`robot-setting/app_login?sn=${params.sn}`, Method.POST, params.data, ContentType.json)
  }
// 最新的日志下载信息
export const logData = (params: any) => {
	return https().request('robot-log/last', Method.GET, params, ContentType.form)
}
// 验证token
export const checkToken = (params: any) => {
	return https().request('alive', Method.GET, params, ContentType.form)
}
// 获取机器人目的地列表
export const getdestinations = (params: any) => {
	return https().request('task/destinations', Method.GET, params, ContentType.form)
}
// 删除机器人
export const deleterobot = (id:string) => {
	return https().request(`robots?id=${id}`, Method.DELETE, {}, ContentType.json)
}